module.exports = __webpack_public_path__ + "img/resident-portal.971ed175.svg";